import React from "react";
import styled from "styled-components";
import Icon from "../../Components/Icons";
import CircularLoader from "../../Components/Icons/circularLoader";
import { color, fontFamily } from "../../Components/Theme";

const Bar = styled.header`
  position: sticky;
  top: 0;
  z-index: 15;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 64px;
  padding: 0 ${(p) => (p.$mobile ? "16px" : "24px")};
  background: ${color("surface")};
  border-bottom: 1px solid ${color("border")};
  font-family: ${() => fontFamily()};
`;

const Title = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  font-weight: 700;
  color: ${color("heading")};
`;

const reset = `
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
`;

const BusinessButton = styled.button`
  ${reset}
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 260px;
  min-height: 44px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: ${color("text")};
  span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  &:hover:not(:disabled) { background: ${color("list")}; }
  &:disabled { cursor: default; }
  &:focus-visible { outline: 2px solid ${color("primary")}; outline-offset: 2px; }
`;

const IconButton = styled.button`
  ${reset}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  &:hover { background: ${color("list")}; }
  &:focus-visible { outline: 2px solid ${color("primary")}; outline-offset: 2px; }
`;

const Avatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${color("primary-light")};
  color: ${color("primary")};
  font-size: 14px;
  font-weight: 700;
`;

export const initialsOf = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
};

const TopBar = ({ title, businessName, canSwitch, onSwitch, loading, onMenuClick, isMobile }) => {
  const initials = initialsOf(businessName);
  return (
    <Bar $mobile={isMobile}>
      <Title>{title}</Title>
      {!isMobile && businessName && (
        <BusinessButton
          type="button"
          disabled={!canSwitch}
          onClick={canSwitch ? onSwitch : undefined}
          title={canSwitch ? "Switch Accounts" : undefined}
        >
          <span>{businessName}</span>
          {canSwitch && <Icon $icon="SwapHoriz" $size="18px" $color="text-muted" />}
        </BusinessButton>
      )}
      <IconButton type="button" aria-label="Notifications">
        <Icon $size="24px" $icon="NotificationsNone" $color="text-muted" />
      </IconButton>
      <IconButton type="button" aria-label="Account menu" aria-haspopup="menu" onClick={onMenuClick}>
        {loading ? (
          <CircularLoader $color="primary" $size={32} />
        ) : initials ? (
          <Avatar aria-hidden="true">{initials}</Avatar>
        ) : (
          <Icon $size="30px" $icon="AccountCircle" $color="text-muted" />
        )}
      </IconButton>
    </Bar>
  );
};

export default TopBar;
